import Store from 'store/store';

function onPageView(pageId) {
	if (/^i-am-living-proof(-|$)/.test(pageId)) {
		loadFB();
		fbq('init', '354649876183377');
		fbq('trackSingle', '354649876183377', 'PageView');
	}
	if (/^jimmy-and-stiggs(-|$)/.test(pageId)) {
		loadFB();
		fbq('init', '1335451881053685');
		fbq('trackSingle', '1335451881053685', 'PageView');
		gtag('config', 'AW-16953321214');
		loadTikTok();
		window.ttq.load('D0CHTFJC77U7VNGA1KG0');
		window.ttq.instance('D0CHTFJC77U7VNGA1KG0').page();
	}
}

function onTicketClick() {
	const pageId = Store.get().activePage;
	if (pageId === 'jimmy-and-stiggs-showtimes') {
		fbq('trackSingle', '1335451881053685', 'InitiateCheckout');
		gtag('event', 'conversion', { send_to: 'AW-16953321214/Uf-ACJXevsQaEP7N_JM_' });
		window.ttq.instance('D0CHTFJC77U7VNGA1KG0').track('InitiateCheckout');
	}
}

Store.on('LANDING', ({ page }) => onPageView(page));
Store.on('SET_ACTIVE_PAGE', onPageView);
Store.on('TICKET_CONVERSION', onTicketClick);

function loadFB() {
	!function(f, b, e, v, n, t, s) {
		if (f.fbq) return;
		n = f.fbq = function() {
			n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
		};
		if (!f._fbq) f._fbq = n;
		n.push = n; n.loaded = !0; n.version = '2.0';
		n.queue = []; t = b.createElement(e); t.async = !0;
		t.src = v; s = b.getElementsByTagName(e)[0];
		s.parentNode.insertBefore(t, s);
	}(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
}

function loadTikTok() {
	!function (w, d, t, ttq, i) {
		if (w[t]) return;
		w.TiktokAnalyticsObject = t; ttq = w[t] = w[t] || [];
		ttq.methods = ['page', 'track', 'identify', 'instances', 'debug', 'on', 'off', 'once', 'ready', 'alias', 'group', 'enableCookie', 'disableCookie', 'holdConsent', 'revokeConsent', 'grantConsent'],
		ttq.setAndDefer = function(t, e) {
			t[e] = function() {
				t.push([e].concat(Array.prototype.slice.call(arguments, 0)));
			};
		};
		for (i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i]);
		ttq.instance = function(t, e, n) {
			for (e = ttq._i[t] || [], n = 0; n < ttq.methods.length; n++) ttq.setAndDefer(e, ttq.methods[n]);
			return e;
		}, ttq.load = function(e, n, r, o) {
			r = 'https://analytics.tiktok.com/i18n/pixel/events.js', o = n && n.partner;
			ttq._i = ttq._i || {}, ttq._i[e] = [], ttq._i[e]._u = r, ttq._t = ttq._t || {},
			ttq._t[e] = +new Date, ttq._o = ttq._o || {}, ttq._o[e] = n || {};
			n = document.createElement('script');
			n.type = 'text/javascript', n.async = !0, n.src = r + '?sdkid=' + e + '&lib=' + t;
			e = document.getElementsByTagName('script')[0];
			e.parentNode.insertBefore(n, e);
		};
	}(window, document, 'ttq');
}
